var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-container relative" }, [
    _c("div", { ref: "controls", staticClass: "controls" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control left-[30px] lg:left-[0px]"
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.svg("arrow-left", "h-[10px] stroke-white"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "bg-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control right-[30px] lg:right-[0px]"
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.svg("arrow-right", "h-[10px] stroke-white"))
            }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "slider", staticClass: "slider" },
      _vm._l(_vm.articles, function(article) {
        return _c(
          "div",
          { key: article.id },
          [
            _c("blog-card", {
              staticClass: "bg-black p-[32px] min-h-[180px]",
              attrs: { article: article, theme: _vm.theme, "hide-image": true }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }